import { useCallback, useState } from 'react';
import cx from 'classnames';
import { useTranslation } from 'next-i18next';

import { Icon } from 'components';

import styles from './Faqs.module.scss';

type FaqsProps = {
  className?: string;
  list: Array<{ question: string; answer: string }>;
};

export const Faqs: React.FC<FaqsProps> = ({ className, list }) => {
  const [t] = useTranslation('opportunity');
  const [listExpanded, setListExpanded] = useState<Array<boolean>>(Array(list.length).fill(false));

  const onToggle = useCallback((index: number) => {
    setListExpanded((prev) => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  }, []);

  return (
    <article className={cx(styles.container, className)}>
      <h3 className={styles.heading}>{t('summary-sections.faqs')}</h3>
      {list.map((item, index) => {
        const expanded = listExpanded[index];
        return (
          <section key={index} className={styles.item} onClick={() => onToggle(index)}>
            <h3 className={styles.question}>
              <span>{item.question}</span>
              <Icon iconName={listExpanded[index] ? 'icon_minus-circle' : 'icon_plus-circle'} size="xmediumplus" className={styles.icon} />
            </h3>
            <p className={cx(styles.answer, { [styles.hidden]: !expanded })}>{item.answer}</p>
          </section>
        );
      })}
    </article>
  );
};
